import {isPC} from '../consist/config'

import modalHelper from '../util/modalHelper'

export default () => {
  $('.icon-menu').on('click', function () {
    const $menuBord = $('.x-header-nav')

    if ($(this).hasClass('is-expand')) {
      modalHelper.looseBody()
    } else {
      modalHelper.fixedBody()
    }

    $(this).toggleClass('is-expand')
    $menuBord.toggleClass('is-expand')
  })

  const scrollToHashTarget = ()=>{
    const $target = $('.x-hash-target')

    if ($target.length) {
      $('html,body').animate({
        scrollTop: $target.offset().top - 32
      }, 0)
      return false
    }
  }

  if (isPC && (window.location.href.indexOf('owel-top.html') > 0 || window.location.href.indexOf('yubikitas-top.html') > 0)) {
    $('.x-hash-link').attr('href', 'javascript:;');

    $('.x-hash-link').on('click', function () {

      scrollToHashTarget()

    })
  }

  if (!isPC) {
    $('.x-hash-link').attr('href', 'javascript:;');

    $('.x-hash-link').on('click', function () {
      const $menuBord = $('.x-header-nav')
      const $iconMenu = $('.icon-menu')

      modalHelper.looseBody()

      $iconMenu.removeClass('is-expand')
      $menuBord.removeClass('is-expand')

      scrollToHashTarget()
    })

  }

}